import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
  Card,
  Image,
  Dimmer,
  Header,
  Label,
} from 'semantic-ui-react'
import { Link } from 'react-router-dom'

import './map-card-group.css'
import { getLayerType } from '../../constants/layer-types'
import defaultMapImg from '../../assets/images/map-default.svg'


const propTypes = {
  items: PropTypes.array.isRequired,
  perRow: PropTypes.number,
  url: PropTypes.string.isRequired,
}

const defaultProps = { perRow: 4 }

class MapCardGroup extends Component {
  state = { active: null }

  handleShow = (id) => () => this.setState({ active: id })

  handleHide = () => this.setState({ active: null })

  dimmerContent = ({ name, description, reports }) => (
    <div>
      <Header as='h3' inverted content={name} />
      <Header as='h5' inverted content={description} />
      {reports.map(([, reportID]) => (
        <Header
          as='h5'
          inverted
          key={reportID}
        >
          <div>
            <Label content={getLayerType(reportID).fullName} />
          </div>
        </Header>
      ))}
    </div>
  )

  render() {
    const { active } = this.state

    return (
      <Card.Group itemsPerRow={this.props.perRow}>
        {
          this.props.items.map((map) => (
            <Card
              className='cardContainer'
              fluid
              key={map.map_id}
              as={Link}
              link
              to={`${this.props.url}/${map.map_id}`}
              onMouseEnter={this.handleShow(map.map_id)}
              onMouseLeave={this.handleHide}
            >
              <Dimmer.Dimmable
                dimmed={active === map.map_id}
              >
                <Dimmer
                  active={active === map.map_id}
                  content={this.dimmerContent(map)}
                />
                <div id='helper' />
                {' '}
                {/* helper to keep image height the same as its width */}
                <Image
                  size='medium'
                  src={map.tld ? `//logo.clearbit.com/${map.tld}?size=400` : defaultMapImg}
                  onError={(e) => { e.target.src = defaultMapImg }}
                />
              </Dimmer.Dimmable>
              <div className='cardText'>
                <Card.Header>
                  {map.name}
                </Card.Header>
              </div>
            </Card>
          ))
        }
      </Card.Group>
    )
  }
}

MapCardGroup.propTypes = propTypes
MapCardGroup.defaultProps = defaultProps

export default MapCardGroup
